import { createContext } from 'react';

const ManagerDashboardContext = createContext();
export default ManagerDashboardContext;
